export default __webpack_public_path__ + "static/media/equipment-pathway.bbf89cb7.jpg";